import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Error.module.css";
import { useSelector } from "react-redux";
import ErrorImage from "@_assets/images/embarrassed.png";

function Error() {
  const { t } = useTranslation();
  const customerDetails = useSelector((state) => state.customerReducer);

  // Handle different error formats (object with error_message, string, Error object, etc.)
  const getErrorMessage = () => {
    const { message } = customerDetails;
    
    if (!message) {
      return "An error occurred. Please try again later.";
    }
    
    if (typeof message === "string") {
      return message;
    }
    
    if (typeof message === "object") {
      return message.error_message || message.message || "An error occurred. Please try again later.";
    }
    
    return "Unable to connect to the server. Please try again later.";
  };

  return (
    <div className={styles.error_page_container}>
      <div className={styles.error_page_text}>
        <h1 className={styles.error_oops}>{t("_oops")}</h1>
        <h2>{getErrorMessage()}</h2>
      </div>
      <div className={styles.image_container}>
        <img
          src={ErrorImage}
          alt="embarrassed dinosaur"
          className={styles.error_image}
        />
        <div className={styles.icon_credit}>
          {"icons made by "}
          <a href="https://www.freepik.com" title="Freepik">
            Freepik
          </a>{" "}
          {t("_from")}{" "}
          <a href="https://www.flaticon.com/" title="Flaticon">
            www.flaticon.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default Error;
